<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row>
        <b-col>
          <b-card>
            <b-row class="mb-3">
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("docnumber") }}</label>
                  <b-form-input
                    disabled
                    :placeholder="$t('docnumber')"
                    v-model="PurchaseRequisitionForNextYear.docnumber"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("docdate") }}</label>
                  <!-- <date-picker
                    v-model="PurchaseRequisitionForNextYear.docdate"
                    format="DD.MM.YYYY"
                    style="width:100%"
                    value-type="format"
                    :editable="true"
                    :placeholder="$t('docdate')"
                  ></date-picker> -->
                  <custom-date-picker
                    v-model="PurchaseRequisitionForNextYear.docdate"
                    format="DD.MM.YYYY"
                    type="date"
                    :clearable="false"
                    :placeholder="$t('docdate')"
                    @keyup="BindValueDocdate"
                  >
                  </custom-date-picker>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("finyear") }}</label>
                  <v-select
                    :options="FinYearList"
                    :reduce="(item) => item"
                    :placeholder="$t('ChooseBelow')"
                    label="name"
                    v-model="PurchaseRequisitionForNextYear.finyear"
                  ></v-select>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col>
          <b-card>
            <b-row>
              <b-col sm="12" md="12">
                <div>
                  <label>{{ $t("detailinfo") }}</label>
                  <b-form-textarea
                    :placeholder="$t('detailinfo')"
                    v-model="PurchaseRequisitionForNextYear.detailinfo"
                    type="text"
                  ></b-form-textarea>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12" md="12" lg="12">
          <b-card>
            <b-row>
              <b-col
                cols="12"
                class="text-right mb-2"
                style="text-align:end !important"
              >
                <b-button @click="OpenModal" size="sm" variant="primary">
                  <i class="bx bx-plus"></i>
                  {{ $t("Add") }}
                </b-button>
              </b-col>
            </b-row>
            <b-table
              :fields="fields"
              bordered
              responsive
              :busy="isLoading"
              head-row-variant="info"
              sticky-header="60vh"
              no-border-collapse
              striped
              small
              :items="PurchaseRequisitionForNextYearTable.MonthTables"
              class="text-center"
              :tbody-tr-class="rowClass"
            >
              <template #cell(Quater1)="{item}">
                {{ item.QuantityByPeriod.Quarter1 }}
              </template>
              <template #cell(Quater2)="{item}">
                {{ item.QuantityByPeriod.Quarter2 }}
              </template>
              <template #cell(Quater3)="{item}">
                {{ item.QuantityByPeriod.Quarter3 }}
              </template>
              <template #cell(Quater4)="{item}">
                {{ item.QuantityByPeriod.Quarter4 }}
              </template>
              <template #cell(Yearly)="{item}">
                {{ item.QuantityByPeriod.Yearly }}
              </template>

              <template #cell(actions)="{ item }">
                <div class="text-center">
                  <b-link>
                    <i
                      style="margin-right: 5px"
                      @click="Edit(item)"
                      class="bx bx-pencil"
                    ></i>
                  </b-link>
                  <b-link>
                    <i @click="DeleteRow(item)" class="bx bx-trash-alt"></i>
                  </b-link>
                </div>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>

      <b-modal
        size="xl"
        v-model="ModalShow"
        no-close-on-backdrop
        hide-footer
        :title="$t('Tables')"
      >
        <b-card class="mb-0 pb-0" style="border: 2px solid #F0EAD6">
          <b-row>
            <!-- <b-col sm="12" md="4">
              <div>
                <label>{{ $t("productcategory") }}</label>
                <v-select
                  :options="ProductCategoryList"
                  :reduce="(item) => item.id"
                  :placeholder="$t('ChooseBelow')"
                  label="name"
                  v-model="tabrow.productcategoryid"
                  @input="ChangeProductCategoryTable"
                ></v-select>
              </div>
            </b-col>

            <b-col sm="12" md="4">
              <div>
                <label>{{ $t("product") }}</label>
                <v-select
                  :options="ProductList"
                  :reduce="(item) => item.id"
                  :placeholder="$t('ChooseBelow')"
                  label="name"
                  v-model="tabrow.productid"
                  @input="ChangeProductTable"
                ></v-select>
              </div>
            </b-col>
            <b-col sm="12" md="4">
              <div>
                <label for>{{ $t("unitofmeasure") }}</label>
                <v-select
                  :options="UnitOfMeasureList"
                  :reduce="(item) => item.id"
                  :placeholder="$t('ChooseBelow')"
                  label="name"
                  v-model="tabrow.unitofmeasureid"
                  @input="ChangeUnitOfMeasureTable"
                ></v-select>
              </div>
            </b-col> -->
            <b-col sm="12" md="4">
              <div class="form-group form-row">
                <label class="col-form-label col-sm-12" for>{{
                  $t("productcategory")
                }}</label>
                <div class="col-sm-12">
                  <b-input-group>
                    <b-form-input
                      disabled
                      :placeholder="$t('productcategory')"
                      v-model="tabrow.productenktcode"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" @click="OpenProductModal">
                        <i class="mdi mdi-account-plus"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </div>
            </b-col>
            <b-col sm="12" md="4">
              <div class="form-group form-row">
                <label class="col-form-label col-sm-12" for>{{
                  $t("product")
                }}</label>
                <div class="col-sm-12">
                  <b-form-input
                    disabled
                    class="ml-n3"
                    :placeholder="$t('product')"
                    v-model="tabrow.productname"
                  />
                </div>
              </div>
            </b-col>
            <b-row>
              <b-col>
                <b-modal
                  size="xl"
                  no-close-on-backdrop
                  hide-footer
                  :title="$t('Tables')"
                  v-model="ProductInfoModal"
                >
                  <b-row>
                    <b-col sm="12" lg="5">
                      <div class="form-group form-row m-2">
                        <label class="col-form-label col-sm-4" for>{{
                          $t("productcategory")
                        }}</label>
                        <div class="col-sm-8">
                          <v-select
                            :options="GetENKTPropertiesList"
                            :reduce="(item) => item.Number"
                            :placeholder="$t('ChooseBelow')"
                            label="Value"
                            v-model="tabrowSpec.propertiesnumber"
                            @input="ChangeENKT"
                          ></v-select>
                        </div>
                      </div>
                    </b-col>
                    <b-col sm="12" lg="5">
                      <div class="form-group form-row m-2">
                        <label class="col-form-label col-sm-4" for>{{
                          $t("product")
                        }}</label>
                        <div class="col-sm-8">
                          <v-select
                            :options="GetENKTPropertiesValuesList"
                            :reduce="(item) => item.ValueNumber"
                            :placeholder="$t('ChooseBelow')"
                            label="Value"
                            v-model="tabrowSpec.propertiesvaluesnumber"
                            @input="ChangeENKT2"
                          ></v-select>
                        </div>
                      </div>
                    </b-col>
                    <!-- <b-col sm="12" lg="2" class="text-center">
                  <b-button
                    class="mt-2"
                    @click="AddSpecTable"
                    size="sm"
                    variant="outline-primary"
                  >
                    <i class="bx bx-plus"></i>
                  </b-button>
                </b-col> -->
                  </b-row>
                  <b-row class="mt-2">
                    <b-col class="text-right">
                      <b-button
                        class="m-1"
                        @click="ProductInfoModal = false"
                        size="lg"
                        variant="outline-danger"
                      >
                        <i class="dripicons-arrow-thin-left"></i>
                        {{ $t("back") }}
                      </b-button>
                      <b-button
                        class="m-1"
                        @click="AddSpecTable"
                        size="lg"
                        variant="outline-success"
                      >
                        <i class="dripicons-checkmark"></i>
                        {{ $t("Save") }}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-modal>
                <!-- <b-row>
                  <b-col class="text-right">
                    <b-button
                      class="m-1"
                      @click="OpenProductInfoModal"
                      size="xl"
                      variant="outline-primary"
                    >
                      <i class="bx bx-plus"></i>
                      {{ $t("Add") }}
                    </b-button>
                  </b-col>
                </b-row> -->
                <!-- <b-row>
                  <b-col>
                    <b-table
                      :fields="fieldsSpec"
                      bordered
                      responsive
                      :busy="isLoading"
                      head-row-variant="info"
                      sticky-header="60vh"
                      no-border-collapse
                      striped
                      small
                      :items="tabrow.SpecTables"
                      class="text-center"
                      :tbody-tr-class="rowClass"
                    >
                      <template #cell(actions)="{ item }">
                        <div class="text-center">
                          <b-link>
                            <i
                              style="margin-right: 5px"
                              @click="EditProduct(item)"
                              class="bx bx-pencil"
                            ></i>
                          </b-link>
                          <b-link>
                            <i
                              @click="DeleteRow(item)"
                              class="bx bx-trash-alt"
                            ></i>
                          </b-link>
                        </div>
                      </template>
                    </b-table>
                  </b-col>
                </b-row> -->
              </b-col>
            </b-row>
            <b-col sm="12" md="6">
              <div class="mt-2">
                <label>{{ $t("purchasepurpose") }}</label>
                <b-form-textarea
                  :placeholder="$t('purchasepurpose')"
                  v-model="tabrow.purchasepurpose"
                  type="text"
                ></b-form-textarea>
              </div>
            </b-col>
            <b-col sm="12" md="6">
              <div class="mt-2">
                <label>{{ $t("productinfo") }}</label>
                <b-form-textarea
                  :placeholder="$t('productinfo')"
                  v-model="tabrow.productinfo"
                  type="text"
                ></b-form-textarea>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <b-modal
          :title="$t('Product')"
          v-model="ProductModal"
          no-close-on-backdrop
          hide-footer
          size="xl"
        >
          <b-row>
            <b-col sm="12" md="3">
              <b-form-input
                :placeholder="$t('code')"
                v-model="filter2.Code"
              ></b-form-input>
            </b-col>

            <b-col sm="12" md="4">
              <b-input-group>
                <b-form-input
                  :placeholder="$t('search')"
                  v-model="filter2.Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="ProductShow">
                    <i class="fas fa-search"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <div class="row m-2">
            <div class="col">
              <b-table
                :busy="isLoading"
                selected-variant="info"
                :fields="productfields"
                :items="GetENKTList"
                selectable
                sticky-header="120hv"
                responsive
                @row-selected="onRowSelectedProduct"
                select-mode="single"
                show-empty
                :empty-text="$t('NotFound')"
                @row-dblclicked="dblclickitemProduct"
              >
                <template v-slot:empty>
                  <h5 class="text-center">{{ $t("NoItems") }}</h5>
                </template>
                <template v-slot:table-busy>
                  <div
                    class="text-center text-primary my-2"
                    style="vertical-align: middle"
                  >
                    <b-spinner
                      style="margin-right: 10px"
                      class="align-middle"
                    ></b-spinner>
                    <strong>{{ $t("Loading") }}</strong>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
          <div>
            <b-row class="m-2">
              <b-col
                cols="12"
                sm="6"
                class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-start
                "
              >
                <span class="text-muted">
                  {{ $t("Showing") }} {{ firstNumber }} {{ $t("to") }}
                  {{ lastNumber }} {{ $t("of") }} {{ filter2.totalRows }}
                  {{ $t("entries") }}
                </span>
              </b-col>
              <b-col
                cols="12"
                sm="6"
                class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-end
                "
              >
                <b-pagination
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                  @input="ProductShow"
                  :per-page="filter2.PageLimit"
                  :total-rows="filter2.totalRows"
                  v-model="filter2.PageNumber"
                >
                  <template #prev-text>
                    <i class="fas fa-angle-left"></i>
                  </template>
                  <template #next-text>
                    <i class="fas fa-angle-right"></i>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col class="text-center mr-3">
              <b-button
                @click="PersonModal = false"
                class="mr-2"
                variant="danger"
                style="margin-right:5px"
              >
                {{ $t("back") }}
              </b-button>
              <b-button @click="AddProduct(selectedProduct)" variant="success">
                {{ $t("Select") }}
              </b-button>
            </b-col>
          </b-row>
        </b-modal>
        <b-row class="mt-2 mb-0 pb-0">
          <b-col v-if="tabrow.productid != ''">
            <b-card
              class="mb-0 "
              style="border: 2px solid #94BDE7;border-radius: 10px"
            >
              <p class="text-center mt-0 pt-0">{{ $t("UzexPrice") }}</p>
              <b-row>
                <b-col>{{ $t("max") }}:</b-col>
                <b-col class="text-right">
                  <span style="color:red">{{
                    $options.filters.currency(UzexPrice.max, {
                      symbol: "  ",
                      fractionCount: 0,
                    })
                  }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>{{ $t("avg") }}:</b-col>
                <b-col class="text-right">
                  <span style="color:orange">
                    {{
                      $options.filters.currency(UzexPrice.avg, {
                        symbol: "  ",
                        fractionCount: 0,
                      })
                    }}</span
                  >
                </b-col>
              </b-row>

              <b-row>
                <b-col>{{ $t("min") }}:</b-col>
                <b-col class="text-right">
                  <span style="color:green">
                    {{
                      $options.filters.currency(UzexPrice.min, {
                        symbol: "  ",
                        fractionCount: 0,
                      })
                    }}</span
                  >
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col v-if="tabrow.productid != ''">
            <b-card
              class="mb-0"
              style="border: 2px solid #94BDE7;border-radius: 10px"
            >
              <p class="text-center mt-0 pt-0">{{ $t("EduXaridPrice") }}</p>
              <b-row>
                <b-col>{{ $t("max") }}:</b-col>
                <b-col class="text-right">
                  <span style="color:red">{{
                    $options.filters.currency(EduXaridPrice.max, {
                      symbol: "  ",
                      fractionCount: 0,
                    })
                  }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>{{ $t("avg") }}:</b-col>
                <b-col class="text-right">
                  <span style="color:orange">
                    {{
                      $options.filters.currency(EduXaridPrice.avg, {
                        symbol: "  ",
                        fractionCount: 0,
                      })
                    }}</span
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col>{{ $t("min") }}:</b-col>
                <b-col class="text-right">
                  <span style="color:green">{{
                    $options.filters.currency(EduXaridPrice.min, {
                      symbol: "  ",
                      fractionCount: 0,
                    })
                  }}</span>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <p
          class="text-center mt-0 pt-0 mb-0 pb-0"
          style="font-size:22px;font-weight:bold"
        >
          {{ $t("MonthAbout") }}
        </p>
        <b-card style="border: 2px solid #CBE5FC;background-color:#DCEDFC">
          <b-row class="mb-0 pb-0">
            <b-col>
              <div class="form-group form-row  ">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month1")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  :placeholder="$t('month1')"
                  v-model="tabrow.QuantityByPeriod.Month1"
                ></custom-number-input>
              </div>
            </b-col>

            <b-col>
              <div class="form-group form-row ">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month2")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  class="ml-n3"
                  :placeholder="$t('month2')"
                  v-model="tabrow.QuantityByPeriod.Month2"
                ></custom-number-input>
              </div>
            </b-col>
            <b-col>
              <div class="form-group form-row ">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month3")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  class="ml-n3"
                  :placeholder="$t('month3')"
                  v-model="tabrow.QuantityByPeriod.Month3"
                ></custom-number-input>
              </div>
            </b-col>
            <b-col>
              <div class="form-group form-row ">
                <div>
                  <p class="mt-2 mb-1 pb-1">
                    <span style="color:blue;font-size:18px"
                      >{{ $t("Quarter1") }}
                    </span>
                  </p>
                  <p class="text-right" style="color:blue;font-size:18px">
                    {{
                      $options.filters.currency(
                        tabrow.QuantityByPeriod.Quarter1,
                        { symbol: "  ", fractionCount: 2 }
                      )
                    }}
                    {{ tabrow.unitofmeasurename }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-0 pt-0">
            <b-col>
              <div class="form-group form-row ">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month4")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  class="ml-n3"
                  :placeholder="$t('month4')"
                  v-model="tabrow.QuantityByPeriod.Month4"
                ></custom-number-input>
              </div>
            </b-col>

            <b-col>
              <div class="form-group form-row ">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month5")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  class="ml-n3"
                  :placeholder="$t('month5')"
                  v-model="tabrow.QuantityByPeriod.Month5"
                ></custom-number-input>
              </div>
            </b-col>
            <b-col>
              <div class="form-group form-row m-2">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month6")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  class="ml-n3"
                  :placeholder="$t('month6')"
                  v-model="tabrow.QuantityByPeriod.Month6"
                ></custom-number-input>
              </div>
            </b-col>
            <b-col>
              <div class="form-group form-row ">
                <div>
                  <p class="mt-2 mb-1 pb-1">
                    <span style="color:blue;font-size:18px"
                      >{{ $t("Quarter2") }}
                    </span>
                  </p>
                  <p class="text-right" style="color:blue;font-size:18px">
                    {{
                      $options.filters.currency(
                        tabrow.QuantityByPeriod.Quarter2,
                        { symbol: "  ", fractionCount: 2 }
                      )
                    }}
                    {{ tabrow.unitofmeasurename }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="form-group form-row ">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month7")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  class="ml-n3"
                  :placeholder="$t('month7')"
                  v-model="tabrow.QuantityByPeriod.Month7"
                ></custom-number-input>
              </div>
            </b-col>

            <b-col>
              <div class="form-group form-row ">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month8")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  class="ml-n3"
                  :placeholder="$t('month8')"
                  v-model="tabrow.QuantityByPeriod.Month8"
                ></custom-number-input>
              </div>
            </b-col>
            <b-col>
              <div class="form-group form-row ">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month9")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  class="ml-n3"
                  :placeholder="$t('month9')"
                  v-model="tabrow.QuantityByPeriod.Month9"
                ></custom-number-input>
              </div>
            </b-col>
            <b-col>
              <div class="form-group form-row ">
                <div>
                  <p class="mt-2 mb-1 pb-1">
                    <span style="color:blue;font-size:18px"
                      >{{ $t("Quarter3") }}
                    </span>
                  </p>
                  <p class="text-right" style="color:blue;font-size:18px">
                    {{
                      $options.filters.currency(
                        tabrow.QuantityByPeriod.Quarter3,
                        { symbol: "  ", fractionCount: 2 }
                      )
                    }}
                    {{ tabrow.unitofmeasurename }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="form-group form-row ">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month10")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  class="ml-n3"
                  :placeholder="$t('month10')"
                  v-model="tabrow.QuantityByPeriod.Month10"
                ></custom-number-input>
              </div>
            </b-col>

            <b-col>
              <div class="form-group form-row ">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month11")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  class="ml-n3"
                  :placeholder="$t('month11')"
                  v-model="tabrow.QuantityByPeriod.Month11"
                ></custom-number-input>
              </div>
            </b-col>
            <b-col>
              <div class="form-group form-row ">
                <label class="col-form-label col-sm-4" for>{{
                  $t("month12")
                }}</label>
                <custom-number-input
                  @input="Calculate"
                  class="ml-n3"
                  :placeholder="$t('month12')"
                  v-model="tabrow.QuantityByPeriod.Month12"
                ></custom-number-input>
              </div>
            </b-col>
            <b-col>
              <div class="form-group form-row ">
                <div>
                  <p class="mt-2 mb-1 pb-1">
                    <span style="color:blue;font-size:18px"
                      >{{ $t("Quarter4") }}
                    </span>
                  </p>
                  <p class="text-right" style="color:blue;font-size:18px">
                    {{
                      $options.filters.currency(
                        tabrow.QuantityByPeriod.Quarter4,
                        { symbol: "  ", fractionCount: 2 }
                      )
                    }}
                    {{ tabrow.unitofmeasurename }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col></b-col>
            <b-col class="text-right">
              <div>
                <div>
                  <p class="mt-1 mb-1 pb-1" style="color:blue;font-size:18px">
                    <span style="color:blue;font-size:18px"
                      >{{ $t("yearly") }} :</span
                    >
                  </p>
                </div>
              </div>
            </b-col>
            <b-col class="text-left">
              <div>
                <div>
                  <p
                    class="mt-1 mb-1 pb-1 text-left"
                    style="color:blue;font-size:18px"
                  >
                    {{
                      $options.filters.currency(
                        tabrow.QuantityByPeriod.Yearly,
                        { symbol: "  ", fractionCount: 2 }
                      )
                    }}
                    {{ tabrow.unitofmeasurename }}
                  </p>
                </div>
              </div>
            </b-col>
            <b-col></b-col>
            <b-col></b-col>
          </b-row>
        </b-card>

        <b-row>
          <b-col class="text-right">
            <b-button
              @click="ModalShow = false"
              size="lg"
              variant="outline-danger"
            >
              <i class="dripicons-arrow-thin-left"></i>
              {{ $t("back") }}
            </b-button>
            <b-button
              class="m-2"
              @click="AddRow"
              size="lg"
              variant="outline-success"
            >
              <i class="dripicons-checkmark"></i>
              {{ $t("Save") }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
        :title="$t('person')"
        v-model="PersonModal"
        no-close-on-backdrop
        hide-footer
        size="xl"
      >
        <!-- <person /> -->
        <!-- <person></person> -->
        <b-row>
          <b-col sm="12" md="3">
            <!-- <date-picker
              v-model="filter.OnDate"
              format="DD.MM.YYYY"
              style="width:100%"
              value-type="format"s
              :editable="true"
              :placeholder="$t('docdate')"
            ></date-picker> -->
            <custom-date-picker
              v-model="filter.OnDate"
              format="DD.MM.YYYY"
              type="date"
              :clearable="false"
              :placeholder="$t('docdate')"
              @keyup="BindValueFilter"
            >
            </custom-date-picker>
          </b-col>

          <b-col sm="12" md="4">
            <b-input-group>
              <b-form-input
                :placeholder="$t('search')"
                v-model="filter.search"
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="PersonShow">
                  <i class="fas fa-search"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <div class="row m-2">
          <div class="col">
            <b-table
              selected-variant="info"
              :fields="personfields"
              :items="items"
              selectable
              sticky-header="120hv"
              responsive
              @row-selected="onRowSelected"
              select-mode="single"
              show-empty
              :empty-text="$t('NotFound')"
              @row-dblclicked="dblclickitem"
            >
              <template v-slot:empty>
                <h5 class="text-center">{{ $t("NoItems") }}</h5>
              </template>
              <template v-slot:table-busy>
                <div
                  class="text-center text-primary my-2"
                  style="vertical-align: middle"
                >
                  <b-spinner
                    style="margin-right: 10px"
                    class="align-middle"
                  ></b-spinner>
                  <strong>{{ $t("Loading") }}</strong>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div>
          <b-row class="m-2">
            <b-col
              cols="12"
              sm="6"
              class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-start
                "
            >
              <span class="text-muted">
                {{ $t("Showing") }} {{ firstNumber }} {{ $t("to") }}
                {{ lastNumber }} {{ $t("of") }} {{ filter.totalRows }}
                {{ $t("entries") }}
              </span>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-end
                "
            >
              <b-pagination
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="PersonShow"
                :per-page="filter.PageLimit"
                :total-rows="filter.totalRows"
                v-model="filter.PageNumber"
              >
                <template #prev-text>
                  <i class="fas fa-angle-left"></i>
                </template>
                <template #next-text>
                  <i class="fas fa-angle-right"></i>
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col class="text-center mr-3">
            <b-button
              @click="PersonModal = false"
              class="mr-2"
              variant="danger"
              style="margin-right:5px"
            >
              {{ $t("back") }}
            </b-button>
            <b-button @click="AddPerson(selected)" variant="success">
              {{ $t("Select") }}
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col class="text-left">
                <b-button
                  @click="
                    $router.push('/document/purchaserequisitionfornextyear')
                  "
                  class="d-inline-block "
                  variant="danger"
                  ><i class="dripicons-arrow-thin-left"></i>
                  {{ $t("back") }}</b-button
                >
              </b-col>
              <b-col style="text-align: right !important; " class="text-right">
                <b-button
                  v-if="PurchaseRequisitionForNextYear.CanSave"
                  @click="SaveData"
                  class="d-inline-block "
                  variant="success"
                  ><i class="dripicons-checkmark"></i>
                  {{ $t("save") }}</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<script>
import CustomNumberInput from "../../../components/CustomNumberInput.vue";
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import PurchaseRequisitionForNextYearService from "@/services/document/purchaserequistionfornextyear.service";
import PurchaseRequisitionService from "@/services/document/purchaserequisition.service";
import DepartmentService from "@/services/info/department.service";
import ItemOfExpenseService from "@/services/info/itemofexpense.service";
import OrganizationAccountService from "@/services/others/organizationaccount.service";
import ProductService from "@/services/info/product.service";
import ProductCategoryService from "@/services/info/productcategory.service";
import UnitOfMeasureService from "@/services/info/unitofmeasure.service";
import HelperService from "@/services/others/helper.service";
import Multiselect from "vue-multiselect";
import ENKTService from "../../../services/info/ENKT.service";
import CustomDatePicker from "../../../components/customDatePicker.vue";
export default {
  components: {
    Multiselect,
    Layout,
    PageHeader,
    DatePicker,
    vSelect,
    CustomNumberInput,
    CustomDatePicker,
  },
  data() {
    return {
      title: this.$t("PurchaseRequisitionForNextYear"),
      braedcrumb: [
        {
          text: this.$t("Document"),
        },
        {
          text: this.$t("PurchaseRequisitionForNextYear"),
          active: true,
        },
      ],
      items: [],
      GetENKTPropertiesValuesList: [],
      GetENKTPropertiesList: [],
      GetENKTList: [],
      // //  show: false,

      isLoading: false,
      filter: {
        OnDate: "",
        DepartmentID: 0,
        HREmpAppointOrderTypeID: 0,
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 20,
        isTeacher: false,
        oblastid: 0,
        regionid: 0,
        isfarmfy: false,
      },
      fieldsSpec: [
        {
          key: "propertiesname",
          label: this.$t("propertiesname"),
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "propertiesvaluesname",
          label: this.$t("propertiesvaluesname"),
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("actions"),
          thClass: "text-center",
          sortable: true,
        },
      ],

      options: ["Бюджет", "Не бюджет"],
      fields: [
        {
          key: "productenktcode",
          label: this.$t("productcategory"),
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "productname",
          label: this.$t("product"),
          thClass: "text-center",
          sortable: true,
        },
        // {
        //   key: "unitofmeasurename",
        //   label: this.$t("unitofmeasure"),
        //   thClass: "text-center",
        //   sortable: true,
        // },
        // {
        //   key: "purchasepurpose",
        //   label: this.$t("purchasepurpose"),
        //   thClass: "text-center",
        //   sortable: true,
        // },
        {
          key: "Quater1",
          label: this.$t("Quarter1"),
          tdClass: "text-right",
        },
        {
          key: "Quater2",
          label: this.$t("Quarter2"),
          tdClass: "text-right",
        },
        {
          key: "Quater3",
          label: this.$t("Quarter3"),
          tdClass: "text-right",
        },
        {
          key: "Quater4",
          label: this.$t("Quarter4"),
          tdClass: "text-right",
        },
        {
          key: "Yearly",
          label: this.$t("yearly"),
          tdClass: "text-right",
        },

        {
          key: "actions",
          label: this.$t("actions"),
          thClass: "text-center",
          sortable: true,
        },
      ],
      tabrow: {
        id: 0,
        ownerid: 0,
        purchasepurpose: "",
        deliverytime: "",
        // productcategoryid: 0,
        productenktcode: "",
        // productid: 0,
        productname: "",
        productinfo: "",
        // unitofmeasureid: 0,
        // unitofmeasurename: "",
        purchasebase: "",
        organizationaccountid: 0,
        organizationaccountname: "",
        itemofexpenseid: 0,
        itemofexpensename: "",
        SpecTables: [],
        QuantityByPeriod: {
          Month1: 0,
          Month2: 0,
          Month3: 0,
          Month4: 0,
          Month5: 0,
          Month6: 0,
          Month7: 0,
          Month8: 0,
          Month9: 0,
          Month10: 0,
          Month11: 0,
          Month12: 0,
          Quarter1: 0,
          Quarter2: 0,
          Quarter3: 0,
          Quarter4: 0,
          Yearly: 0,
        },
        PriceByPeriod: {
          month1: 0,
          month2: 0,
          month3: 0,
          month4: 0,
          month5: 0,
          month6: 0,
          month7: 0,
          month8: 0,
          month9: 0,
          month10: 0,
          month11: 0,
          month12: 0,
          quarter1: 0,
          quarter2: 0,
          quarter3: 0,
          quarter4: 0,
          yearly: 0,
        },
        SumByPeriod: {
          month1: 0,
          month2: 0,
          month3: 0,
          month4: 0,
          month5: 0,
          month6: 0,
          month7: 0,
          month8: 0,
          month9: 0,
          month10: 0,
          month11: 0,
          month12: 0,
          quarter1: 0,
          quarter2: 0,
          quarter3: 0,
          quarter4: 0,
          yearly: 0,
        },

        Status: 1,
      },
      personvalue: [],
      personfields: [
        {
          key: "inn",
          label: this.$t("inn"),
          sort: true,
        },
        {
          key: "department",
          label: this.$t("department"),
          sort: true,
        },
        {
          key: "personname",
          label: this.$t("personname"),
          sort: true,
        },
        {
          key: "workschedule",
          label: this.$t("workschedule"),
          sort: true,
        },
      ],
      PurchaseRequisitionForNextYear: {},
      PurchaseRequisitionForNextYearTable: {},

      ModalTables: false,
      PersonModal: false,
      ModalShow: false,
      DepartmentList: [],
      // OrganizationList: [],
      FinYearList: [],
      ProductCategoryList: [],
      ProductList: [],
      UnitOfMeasureList: [],
      OrganizationAccountList: [],
      ItemOfExpenseList: [],
      editedIndex1: -1,
      editedIndex2: -1,
      editedIndex3: -1,
      number: [],
      lang: "ru",
      EduXaridPrice: [],
      UzexPrice: [],
      tabrowSpec: {
        id: 0,
        ownerid: 0,
        propertiesnumber: "",
        propertiesname: "",
        propertiesvaluesnumber: "",
        propertiesvaluesname: "",
        Status: 1,
      },
      ProductInfoModal: false,
      ProductModal: false,
      filter2: {
        Code: "",
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 20,
      },
    };
  },
  computed: {
    firstNumber() {
      return (this.filter.PageNumber - 1) * this.filter.PageLimit + 1;
    },
    lastNumber() {
      if (this.filter2.totalRows < this.filter2.PageLimit) {
        return this.filter2.totalRows;
      } else {
        if (
          this.filter2.PageNumber * this.filter2.PageLimit >
          this.filter2.totalRows
        ) {
          return this.filter2.totalRows;
        } else {
          return this.filter2.PageNumber * this.filter2.PageLimit;
        }
      }
    },
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;
    HelperService.GetAllFinYear().then((res) => {
      this.FinYearList = res.data;
    });

    ProductCategoryService.GetAll(this.lang).then((res) => {
      this.ProductCategoryList = res.data;
    });

    UnitOfMeasureService.GetAll().then((res) => {
      this.UnitOfMeasureList = res.data;
    });
    ItemOfExpenseService.GetAll(this.lang).then((res) => {
      this.ItemOfExpenseList = res.data;
    });
    OrganizationAccountService.GetAll(this.lang).then((res) => {
      this.OrganizationAccountList = res.data;
    });
    // DepartmentService.GetAll(this.lang).then((res) => {
    //   this.DepartmentList = res.data;
    // });
    PurchaseRequisitionForNextYearService.Get(this.$route.params.id)
      .then((res) => {
        this.show = false;
        this.PurchaseRequisitionForNextYear =
          res.data.result.PurchaseRequisition;
        this.PurchaseRequisitionForNextYearTable = res.data.result;
      })
      .catch((error) => {
        this.$notification(error.response.data.error, "danger");
      });
    // this.PersonShow();
    // this.ChangeProductTable();
  },
  directives: {},
  methods: {
    BindValueFilter(value){
      this.filter.OnDate = value
    },
    BindValueDocdate(value) {
      this.PurchaseRequisitionForNextYear.docdate = value;
    },
    dblclickitemProduct(GetENKTList) {
      // this.selected = items;
      this.tabrow.productenktcode = GetENKTList.Code;
      this.tabrow.productname = GetENKTList.Value;
      this.PersonModal = false;
      ENKTService.GetENKTPropertiesList(this.tabrow.productenktcode).then(
        (res) => {
          this.GetENKTPropertiesList = res.data;
        }
      );
    },
    onRowSelectedProduct(GetENKTList) {
      this.selectedProduct = GetENKTList;
    },
    ProductShow() {
      this.isLoading = true;
      ENKTService.GetENKTList(
        this.filter2.Code,
        this.filter2.Search,
        this.filter2.SortColumn,
        this.filter2.OrderType,
        this.filter2.PageNumber,
        this.filter2.PageLimit
      )
        .then((res) => {
          this.isLoading = false;
          this.GetENKTList = res.data.rows;
          this.filter2.totalRows = res.data.total;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    AddProduct(selectedProduct) {
      this.tabrow.productenktcode = selectedProduct[0].Code;
      this.tabrow.productname = selectedProduct[0].Value;
      this.ProductModal = false;
      // ENKTService.GetItemOfExpenseListForENKT(this.tabrow.productid).then(
      //   (res) => {
      //     this.ItemOfExpenseListENKT = res.data;
      //   }
      // );
      ENKTService.GetENKTPropertiesList(this.tabrow.productenktcode).then(
        (res) => {
          this.GetENKTPropertiesList = res.data;
        }
      );
    },
    OpenProductModal() {
      this.ProductModal = true;
      (this.filter2 = {
        Code: "",
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 20,
      }),
        this.ProductShow();
    },
    OpenProductInfoModal() {
      this.ProductInfoModal = true;
      this.tabrowSpec = {
        id: 0,
        ownerid: 0,
        propertiesnumber: "",
        propertiesname: "",
        propertiesvaluesnumber: "",
        propertiesvaluesname: "",
        Status: 1,
      };
    },
    AddSpecTable() {
      if (this.editedIndex2 > -1) {
        Object.assign(
          this.tabrow.SpecTables[this.editedIndex2],
          this.tabrowSpec
        );
      } else {
        this.tabrow.SpecTables.push(this.tabrowSpec);
      }
      this.tabrowSpec = {
        id: 0,
        ownerid: 0,
        propertiesnumber: "",
        propertiesname: "",
        propertiesvaluesnumber: "",
        propertiesvaluesname: "",
        Status: 1,
      };
      this.ProductInfoModal = false;
    },
    EditProduct(item) {
      if (item.Status == 0) {
        item.Status = 2;
      }
      this.editedIndex2 = this.tabrow.SpecTables.indexOf(item);
      this.tabrowSpec = Object.assign({}, item);
      this.ProductInfoModal = true;
    },
    ChangeENKT() {
      // if (!!this.tabrowSpec.propertiesnumber) {
      this.tabrowSpec.propertiesvaluesnumber = "";
      this.tabrowSpec.propertiesname = this.GetENKTPropertiesList.filter(
        (item) => this.tabrowSpec.propertiesnumber === item.Number
      )[0].Value;
      ENKTService.GetENKTPropertiesValuesList(
        this.tabrow.productenktcode,
        this.tabrowSpec.propertiesnumber
      ).then((res) => {
        this.GetENKTPropertiesValuesList = res.data;
      });

      // }
    },
    ChangeENKT2() {
      this.tabrowSpec.propertiesvaluesname = this.GetENKTPropertiesValuesList.filter(
        (item) => this.tabrowSpec.propertiesvaluesnumber === item.ValueNumber
      )[0].Value;
      this.tabrowSpec.propertiesvaluesnumber = this.tabrowSpec.propertiesvaluesnumber.toString();
      this.tabrowSpec.propertiesnumber = this.tabrowSpec.propertiesnumber.toString();
    },
    ChangeOrganizationAccount() {
      this.tabrow.organizationaccountname = this.OrganizationAccountList.filter(
        (item) => this.tabrow.organizationaccountid === item.id
      )[0].name;
    },
    ChangeItemOfExpense() {
      this.tabrow.itemofexpensename = this.ItemOfExpenseList.filter(
        (item) => this.tabrow.itemofexpenseid === item.id
      )[0].name;
    },
    onRowSelected(items) {
      this.selected = items;
    },
    dblclickitem(items) {
      // this.selected = items;
      this.PurchaseRequisitionForNextYear.personid = items.personid;
      this.PurchaseRequisitionForNextYear.personname = items.personname;
      this.PersonModal = false;
    },
    PersonShow() {
      // this.isLoading = true;
      HelperService.GetEmployeeListForComponent(
        this.filter.OnDate,
        this.filter.DepartmentID,
        this.filter.HREmpAppointOrderTypeID,
        this.filter.Search,
        this.filter.SortColumn,
        this.filter.OrderType,
        this.filter.PageNumber,
        this.filter.PageLimit,
        this.filter.isTeacher
      )
        .then((res) => {
          this.items = res.data.rows;
          this.filter.totalRows = res.data.total;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    // SelectItem(data) {
    //   this.personvalue = data;
    // },
    AddPerson(selected) {
      this.PersonModal = false;
      this.PurchaseRequisitionForNextYear.personid = selected[0].personid;
      this.PurchaseRequisitionForNextYear.personname = selected[0].personname;
    },
    OpenPersonModal() {
      this.PersonModal = true;
      this.PersonShow();
    },
    ChangePerson() {
      if (!!this.PurchaseRequisitionForNextYear.personid) {
        this.PurchaseRequisitionForNextYear.personname = this.PersonList.filter(
          (item) => this.PurchaseRequisitionForNextYear.personid === item.id
        )[0].name;
      }
    },
    ChangeProductCategoryTable() {
      this.tabrow.productid = 0;
      (this.EduXaridPrice = []), (this.UzexPrice = []);
      if (!!this.tabrow.productcategoryid) {
        ProductService.GetAll(this.tabrow.productcategoryid).then((res) => {
          this.ProductList = res.data;
        });
        this.tabrow.productcategoryname = this.ProductCategoryList.filter(
          (item) => this.tabrow.productcategoryid === item.id
        )[0].name;
      }
    },

    ChangeProductTable() {
      if (!!this.tabrow.productid) {
        this.tabrow.productname = this.ProductList.filter(
          (item) => this.tabrow.productid === item.id
        )[0].name;
        PurchaseRequisitionService.GetStatisticsOfPriceInProduct(
          this.tabrow.productid,
          this.PurchaseRequisitionForNextYear.docdate
        ).then((res) => {
          this.UzexPrice = res.data.result.uzexprice;
          this.EduXaridPrice = res.data.result.eduxaridprice;
        });
      }
    },
    ChangeUnitOfMeasure() {
      if (!!this.tabrow3.unitofmeasureid) {
        this.tabrow3.unitofmeasurename = this.UnitOfMeasureList.filter(
          (item) => this.tabrow3.unitofmeasureid === item.id
        )[0].name;
      }
    },
    ChangeUnitOfMeasureTable() {
      if (!!this.tabrow.unitofmeasureid) {
        this.tabrow.unitofmeasurename = this.UnitOfMeasureList.filter(
          (item) => this.tabrow.unitofmeasureid === item.id
        )[0].name;
      }
    },
    Calculate() {
      this.tabrow.QuantityByPeriod.Quarter1 =
        parseFloat(this.tabrow.QuantityByPeriod.Month1) +
        parseFloat(this.tabrow.QuantityByPeriod.Month2) +
        parseFloat(this.tabrow.QuantityByPeriod.Month3);
      this.tabrow.QuantityByPeriod.Quarter2 =
        parseFloat(this.tabrow.QuantityByPeriod.Month4) +
        parseFloat(this.tabrow.QuantityByPeriod.Month5) +
        parseFloat(this.tabrow.QuantityByPeriod.Month6);
      this.tabrow.QuantityByPeriod.Quarter3 =
        parseFloat(this.tabrow.QuantityByPeriod.Month7) +
        parseFloat(this.tabrow.QuantityByPeriod.Month8) +
        parseFloat(this.tabrow.QuantityByPeriod.Month9);
      this.tabrow.QuantityByPeriod.Quarter4 =
        parseFloat(this.tabrow.QuantityByPeriod.Month10) +
        parseFloat(this.tabrow.QuantityByPeriod.Month11) +
        parseFloat(this.tabrow.QuantityByPeriod.Month12);
      this.tabrow.QuantityByPeriod.Yearly =
        parseFloat(this.tabrow.QuantityByPeriod.Quarter1) +
        parseFloat(this.tabrow.QuantityByPeriod.Quarter2) +
        parseFloat(this.tabrow.QuantityByPeriod.Quarter3) +
        parseFloat(this.tabrow.QuantityByPeriod.Quarter4);
    },

    rowClass(item, type) {
      if (item.Status === 3) return "d-none";
    },
    Edit(item) {
      if (item.Status == 0) {
        item.Status = 2;
      }
      this.editedIndex1 = this.PurchaseRequisitionForNextYearTable.MonthTables.indexOf(
        item
      );
      this.tabrow = Object.assign({}, item);
      this.ModalShow = true;
      ProductService.GetAll(this.tabrow.productcategoryid).then((res) => {
        this.ProductList = res.data;
      });
    },
    DeleteRow(item) {
      item.Status = 3;
    },
    checkTable() {
      if (
        this.tabrow.productenktcode === 0 ||
        this.tabrow.productenktcode === null ||
        this.tabrow.productenktcode === undefined ||
        this.tabrow.productenktcode === ""
      ) {
        this.$notification(this.$t("productcategoryNotSelected"), "danger");
        return false;
      }
      if (
        this.tabrow.productinfo === 0 ||
        this.tabrow.productinfo === null ||
        this.tabrow.productinfo === undefined ||
        this.tabrow.productinfo === ""
      ) {
        this.$notification(this.$t("productinfoNotSelected"), "danger");
        return false;
      }
      if (
        this.tabrow.productname === 0 ||
        this.tabrow.productname === null ||
        this.tabrow.productname === undefined ||
        this.tabrow.productname === ""
      ) {
        this.$notification(this.$t("productNotSelected"), "danger");
        return false;
      }
      // if (
      //   this.tabrow.unitofmeasureid === 0 ||
      //   this.tabrow.unitofmeasureid === null ||
      //   this.tabrow.unitofmeasureid === undefined ||
      //   this.tabrow.unitofmeasureid === ""
      // ) {
      //   this.$notification(this.$t("unitofmeasureNotSelected"), "danger");
      //   return false;
      // }
      if (
        this.tabrow.purchasepurpose === 0 ||
        this.tabrow.purchasepurpose === null ||
        this.tabrow.purchasepurpose === undefined ||
        this.tabrow.purchasepurpose === ""
      ) {
        this.$notification(this.$t("purchasepurposeNotSelected"), "danger");
        return false;
      }

      return true;
    },
    AddRow() {
      if (!this.checkTable()) {
        return false;
      }
      this.save();
    },
    save() {
      if (this.editedIndex1 > -1) {
        Object.assign(
          this.PurchaseRequisitionForNextYearTable.MonthTables[
            this.editedIndex1
          ],
          this.tabrow
        );
      } else {
        this.PurchaseRequisitionForNextYearTable.MonthTables.push(this.tabrow);
      }
      this.ModalShow = false;
    },
    OpenModal() {
      this.ModalShow = true;
      this.tabrow = {
        id: 0,
        ownerid: 0,
        purchasepurpose: "",
        deliverytime: this.PurchaseRequisitionForNextYear.docdate,
        // productcategoryid: 0,
        productenktcode: "",
        // productid: 0,
        productname: "",
        productinfo: "",
        // unitofmeasureid: 0,
        // unitofmeasurename: "",
        purchasebase: "",
        organizationaccountid: 0,
        organizationaccountname: "",
        itemofexpenseid: 0,
        itemofexpensename: "",
        SpecTables: [],
        QuantityByPeriod: {
          Month1: 0,
          Month2: 0,
          Month3: 0,
          Month4: 0,
          Month5: 0,
          Month6: 0,
          Month7: 0,
          Month8: 0,
          Month9: 0,
          Month10: 0,
          Month11: 0,
          Month12: 0,
          Quarter1: 0,
          Quarter2: 0,
          Quarter3: 0,
          Quarter4: 0,
          Yearly: 0,
          Sum: 0,
        },
        PriceByPeriod: {
          month1: 0,
          month2: 0,
          month3: 0,
          month4: 0,
          month5: 0,
          month6: 0,
          month7: 0,
          month8: 0,
          month9: 0,
          month10: 0,
          month11: 0,
          month12: 0,
          quarter1: 0,
          quarter2: 0,
          quarter3: 0,
          quarter4: 0,
          yearly: 0,
        },
        SumByPeriod: {
          month1: 0,
          month2: 0,
          month3: 0,
          month4: 0,
          month5: 0,
          month6: 0,
          month7: 0,
          month8: 0,
          month9: 0,
          month10: 0,
          month11: 0,
          month12: 0,
          quarter1: 0,
          quarter2: 0,
          quarter3: 0,
          quarter4: 0,
          yearly: 0,
        },

        Status: 1,
      };
      this.editedIndex1 = -1;
    },
    check() {
      if (
        this.PurchaseRequisitionForNextYear.docnumber === 0 ||
        this.PurchaseRequisitionForNextYear.docnumber === null ||
        this.PurchaseRequisitionForNextYear.docnumber === undefined ||
        this.PurchaseRequisitionForNextYear.docnumber === ""
      ) {
        this.$notification(this.$t("docnumberNotSelected"), "danger");
        return false;
      }
      if (
        this.PurchaseRequisitionForNextYear.docdate === 0 ||
        this.PurchaseRequisitionForNextYear.docdate === null ||
        this.PurchaseRequisitionForNextYear.docdate === undefined ||
        this.PurchaseRequisitionForNextYear.docdate === ""
      ) {
        this.$notification(this.$t("docdateNotSelected"), "danger");
        return false;
      }
      if (
        this.PurchaseRequisitionForNextYear.finyear === 0 ||
        this.PurchaseRequisitionForNextYear.finyear === null ||
        this.PurchaseRequisitionForNextYear.finyear === undefined ||
        this.PurchaseRequisitionForNextYear.finyear === ""
      ) {
        this.$notification(this.$t("finyearNotSelected"), "danger");
        return false;
      }
      if (this.PurchaseRequisitionForNextYearTable.MonthTables.length === 0) {
        this.$notification(this.$t("TablesNotSelected"), "danger");
        return false;
      }
      return true;
    },
    ChangeDepartment() {
      if (!!this.PurchaseRequisitionForNextYear.departmentid) {
        this.PurchaseRequisitionForNextYear.departmentname = this.DepartmentList.filter(
          (item) => this.PurchaseRequisitionForNextYear.departmentid === item.id
        )[0].name;
      }
    },
    ChangeDepartmentTable() {
      if (!!this.tabrow.departmentid) {
        this.tabrow.departmentname = this.DepartmentList.filter(
          (item) => this.tabrow.departmentid === item.id
        )[0].name;
      }
    },

    SaveData() {
      if (!this.check()) {
        return false;
      }
      PurchaseRequisitionForNextYearService.Update({
        MonthTables: this.PurchaseRequisitionForNextYearTable.MonthTables,
        PurchaseRequisition: this.PurchaseRequisitionForNextYear,
      })
        .then((res) => {
          this.$notification(this.$t("SaveSuccess"), "success");
          this.$router.push({ name: `purchaserequisitionfornextyear` });
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
        });
    },
  },
};
</script>

<style>
/* .mx-input {
  background-color: #eff2f7 !important;
} */
.text-right {
  text-align: right;
}
</style>
